export default "__VITE_ASSET__DVCQoAYs__"